<template>
  <div class="home">
    <h1>Course Info</h1>
    <p><b>Starting March 30,</b> lectures and office hours will be held via Zoom.
      See <a href="https://elearning.mines.edu/courses/21539/pages/zoom-connection-info" target="_blank">Canvas</a> for Zoom meeting room information.</p>

    <table class="unlined-table">
      <tr>
        <td>Section&nbsp;A:</td>
        <td>MWF 10:00-10:50<!--, BE 243--></td>
      </tr>
      <tr>
        <td>Section&nbsp;B:</td>
        <td>MWF 11:00-11:50<!--, BE 243--></td>
      </tr>
      <tr>
        <td>Textbook: </td>
        <td><a href="http://www.mypearsonstore.com/bookstore/fundamentals-of-database-systems-0133970779" target="_blank"><i>Fundamentals of Database Systems</i> by Elmasri and Navathe</a></td></tr>
      <tr>
        <td>links: </td>
        <td><a href="https://elearning.mines.edu/login/saml" target="_blank">Canvas</a></td>
      </tr>
      <tr>
        <td></td>
        <td><a href="https://piazza.com/mines/spring2020/csci403" target="_blank">Piazza</a></td>
      </tr>
    </table>
    
    <h2>Instructor Info</h2>
    <table class="unlined-table">
      <tr>
        <td>
            <a href="http://inside.mines.edu/~cpainter" target="_blank">
                <img src="../assets/photos/cpw.jpg" width="120" alt="Christopher Painter-Wakefield" />
            </a>
        </td>
        <td>
          <table class="unlined-table">
            <tr>
              <td>Instructor: </td>
              <td>
                <a href="http://inside.mines.edu/~cpainter" target="_blank">Christopher Painter&#8209;Wakefield</a>  
                <br/>
                <i>(he, him, his)</i>
              </td>
            </tr>
            <tr>
              <td>Office: </td>
              <td>BB 280N</td>
            </tr>
            <tr>
              <td>Phone: </td>
              <td>303-273-3717</td>
            </tr>
            <tr>
              <td>email: </td>
              <td><a href="mailto:cpainter@mines.edu">cpainter@mines.edu</a></td>
            </tr>
          </table>
        </td>
      </tr>
    </table> 

    <h2>Office Hours</h2>
 <!--   <p><b>TBD</b></p> -->

    <p><b>Starting March 30,</b> lectures and office hours will be held via Zoom.
      See <a href="https://elearning.mines.edu/courses/21539/pages/zoom-connection-info" target="_blank">Canvas</a> for Zoom meeting room information.</p>

 <!--   <p>Office hours this semester will be held in BB 280K (inside Suite 280, the
 large open area outside CPW's office).</p>-->

    <table class="lined-table">
      <tr>
        <td><b>Mondays</b></td>
        <td></td>
      </tr>
      <tr>
        <td><b>Tuesdays</b></td>
        <td>
          11am - Noon (Steven)
          <br/>
          2 - 3pm (CPW)
        </td>
      </tr>
      <tr>
        <td><b>Wednesdays</b></td>
        <td>
          12:30 - 1:30pm (James)
          <br/>
          4 - 5pm (CPW)
        </td>
      </tr>
      <tr>
        <td><b>Thursdays</b></td>
        <td></td>
      </tr>
      <tr>
        <td><b>Fridays</b></td>
        <td>
          Noon - 1pm (James)
          <br/>
          4:30 - 5:30pm (Steven)
        </td>
      </tr>
    </table>

    <h2>TA Staff</h2>
   <!-- <p><b>Coming soon!</b></p>-->

    <div class="ta-list">
      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/james.jpg" alt="James Schreiner" class="portrait"/></div>
        <div class="ta-item">James Schreiner</div>
      </div>

      <div class="ta-entry">
        <div class="ta-item"><img src="../assets/photos/steven.jpg" alt="Steven Vennard" class="portrait"/></div>
        <div class="ta-item">Steven Vennard</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
